import React from 'react';
import { getAvatar, avatarSrc } from './avatarRegistry';
import './Avatar.css';

const SIZES = { xs: 28, sm: 36, md: 48, lg: 72, xl: 104 };

/**
 * One avatar by persisted id, or an honest initials disc when the student has not chosen one yet
 * (never blocks rendering, never guesses). `size`: xs|sm|md|lg|xl or a number of px.
 */
export default function Avatar({ avatarId, name, size = 'md', ring = false, className = '' }) {
  const px = typeof size === 'number' ? size : (SIZES[size] || SIZES.md);
  const avatar = getAvatar(avatarId);

  if (!avatar) {
    const initial = (name || '?').trim().charAt(0).toUpperCase();
    return (
      <span
        className={`z-avatar z-avatar--fallback ${ring ? 'z-avatar--ring' : ''} ${className}`.trim()}
        style={{ width: px, height: px, fontSize: Math.round(px * 0.42) }}
        role="img"
        aria-label={name ? `${name}'s avatar (not yet chosen)` : 'Avatar not yet chosen'}
      >
        {initial}
      </span>
    );
  }

  return (
    <span
      className={`z-avatar ${ring ? 'z-avatar--ring' : ''} ${className}`.trim()}
      style={{ width: px, height: px, background: avatar.tone || undefined }}
      role="img"
      aria-label={`${avatar.name} avatar`}
    >
      <img className="z-avatar-img" src={avatarSrc(avatar)} width={px} height={px} alt="" decoding="async" draggable={false} />
    </span>
  );
}
